import type { RootState } from '@/app/store'
import Link from 'next/link'
import React, { useState, useRef, useEffect } from 'react'
import { useSelector } from 'react-redux'
// Import Swiper React components & Swiper styles
import { Swiper, SwiperSlide } from 'swiper/react'
import { Virtual, Pagination } from 'swiper/modules'
import { useTranslation } from 'react-i18next'

interface SpotInSheetCardProps extends Api.SpotInSheetObject {
  slideIndex: number
}

const SwiperGoogleMap = ({
  spotInSheet,
}: {
  spotInSheet: Api.SpotInSheetObject[]
}) => {
  const { t } = useTranslation()
  const [swiperArrayState, setSwiperMapArrayState] = useState<boolean>(false)
  const [spotInSheetToSwiper, setSpotInSheetToSwiper] = useState<SpotInSheetCardProps[]>([])

  const slideStateSelector = useSelector((state: RootState) => state.spotMap.slideIndex)
  const spotIdToSliceIndexSelector = useSelector((state: RootState) => state.spotMap.spotIdToSliceIndex)

  const ref = useRef(null)

  useEffect(() => {
    setSwiperMapArrayState(false)
    setTimeout(() => {
      setSwiperMapArrayState(true)
    }, 0)

    return
  }, [spotInSheet])

  useEffect(() => {
    if (ref.current?.swiper) {
      ref.current.swiper.slideTo(Number(slideStateSelector))
    }
    return
  }, [slideStateSelector])

  useEffect(() => {
    const spotIdsInClusteredIds = spotIdToSliceIndexSelector.map((v) => v.spotId)
    setSpotInSheetToSwiper(
      spotInSheet
        .filter((v) => spotIdsInClusteredIds.includes(v.id))
        .map((v) => {
          const targetSpot = spotIdToSliceIndexSelector.filter((s) => s.spotId === v.id)[0]
          return {
            ...v,
            slideIndex: targetSpot.sliceIndex,
          }
        }),
    )
    if (ref.current?.swiper) {
      ref.current.swiper.slideTo(0)
    }

    setSwiperMapArrayState(false)
    setTimeout(() => {
      setSwiperMapArrayState(true)
    }, 0)
  }, [spotIdToSliceIndexSelector])

  return (
    <div className="c-swiper_map-wrap">
      {swiperArrayState ? (
        <Swiper
          modules={[Virtual, Pagination]}
          loop={false}
          speed={1000}
          spaceBetween={10}
          slidesPerView={1.35}
          centeredSlides={true}
          ref={ref}
          virtual
        >
          {spotInSheetToSwiper.map((content, i: number) => {
            return (
              <SwiperSlide key={content.id} virtualIndex={content.id}>
                <Link
                  href={{
                    pathname: '/spot/detail/',
                    query: {
                      query: content.id,
                    },
                  }}
                >
                  <a className="border-gray-200 c-swiper_contents flex items-center border-b pt-2 pb-1">
                    <div className="c-thumbnail_min-wrap">
                      <span className="c-thumbnail_min block">
                        <img src={content.image ? content.image : ''} alt="" />
                      </span>
                    </div>
                    <div className="ml-2">
                      <p className="c_clamp c_clamp_12 text-xsss font-bold">{content.name}</p>
                      <p className="c_clamp c_clamp_12 text-xs">{content.address}</p>
                      <div className="mt-1 flex flex-wrap items-center">
                        {!content.isStamp ? (
                          <p className="c-tag text-xss text-sub">
                            {t('spot_detail.other_recommendation', 'その他おすすめ')}
                          </p>
                        ) : (
                          <>
                            {content.stamp ? (
                              <p className="c-status mr-2 text-xss text-color01">
                                {`${
                                  content.stamp.isHas
                                    ? t('spot_detail.acquired', '獲得済み')
                                    : t('spot_detail.un_acquired', '未獲得')
                                }`}
                              </p>
                            ) : (
                              ''
                            )}
                            {content.sheetNames ? (
                              <>
                                {content.sheetNames.map((v: string, i: number) => {
                                  return (
                                    <p className="c-tag c_clamp mr-2 mb-1 inline-block text-xss text-sub" key={v}>
                                      {v}
                                    </p>
                                  )
                                })}
                              </>
                            ) : (
                              ''
                            )}

                            {content.isCoupon && (
                              <p className="c-tag c-tag--coupon c_clamp mr-2 mb-1 inline-block text-xss">
                                {t('spot_detail.coupon', 'クーポン')}
                              </p>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </a>
                </Link>
              </SwiperSlide>
            )
          })}
        </Swiper>
      ) : (
        <></>
      )}
    </div>
  )
}

export default SwiperGoogleMap
